import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, useJsApiLoader, InfoWindow, Polyline } from '@react-google-maps/api';
import moment from 'moment';
import './ReportPagePerc.css';
import Conect from '../../../../Api/Conect';
import pin from "../../../assets/marker.png"
import NotificationsAlert from '../../../services/NotificationsAlert';
import LoadingOverlayManager from '../../../services/LoadingOverlayManager';

const ReportPagePerc = () => {
    const token = localStorage.getItem("restoken");
    const id_cli = localStorage.getItem('resid_cli');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [vehicleId, setVehicleId] = useState('');
    const [trip, setTrip] = useState(0);
    const [vehicles, setVehicles] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [centerPositions, setCenterPositions] = useState({ lat: -31.72978671059568, lng: -52.343938513840065, zoom: 13 })
    const [selectedPosition, setSelectedPosition] = useState(null)

    // UseJsApiLoader com constantes para evitar mudanças de configuração
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyChY0qKEv0A5uZX5eoibw0aSZbbs3zxfnM"
    })

    useEffect(() => {
        const setInitialDates = () => {
            setStartDate(moment().startOf('day').format('YYYY-MM-DDTHH:mm'));
            setEndDate(moment().endOf('day').format('YYYY-MM-DDTHH:mm'));
        };

        const getVehicles = async () => {
            if (token && id_cli) {
                try {
                    const response = await Conect.post(`/dmVoaWNsZXNDbGllbnRMaXN0${token}`, { id_cli });
                    if (response.data.erro) {
                        NotificationsAlert("warning", "Atenção", response.data.msg);
                    } else {
                        setVehicles(response.data.vehicles || []);
                    }
                } catch (error) {
                    console.error("Erro ao buscar veículos:", error);
                }
            }
        };

        setInitialDates(); // Defina as datas inicialmente
        getVehicles(); // Busque as posições dos veículos
    }, [token, id_cli]);

    const handleSubmit = async (e) => {
        setReportData([])
        LoadingOverlayManager.show();

        e.preventDefault();
        const HR_INICIAL = moment(startDate, "YYYY-MM-DDTHH:mm").format("HH:mm:ss");
        const DT_INICIAL = moment(startDate, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");

        const HR_FINAL = moment(endDate, "YYYY-MM-DDTHH:mm").format("HH:mm:ss");
        const DT_FINAL = moment(endDate, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");


        let hrInicial = moment(HR_INICIAL, 'HH:mm:ss').add(3, 'hours').format('HH:mm:ss');
        let hrFinal = moment(HR_FINAL, 'HH:mm:ss').add(3, 'hours').format('HH:mm:ss');
        let dtFinal = moment(DT_FINAL).add(1, 'day').format('YYYY-MM-DD');

        const data = {
            id: vehicleId,
            startDate: `${DT_INICIAL} ${hrInicial}`,
            endDate: `${dtFinal} ${hrFinal}`,
        };

        try {

            const response = await Conect.post(`/b2xkcG9zaXRpb25z${token}`, data);
            if (!response.data.erro) {
                LoadingOverlayManager.hide();
                let res = response.data.vehiclePosition
                var trip = ((res[res.length - 1].odometerGps) - res[0].odometerGps)
                setTrip(trip)
                var dados = res.map((value, index) => {
                    return (<Marker
                        key={index}
                        position={{ lat: value.latitude, lng: value.longitude }}
                        onClick={() => {
                            setSelectedPosition(value)
                            setCenterPositions({ lat: value.latitude, lng: value.longitude, zoom: 19 })
                        }}
                        options={{
                            label: {
                                text: `${index}`,
                                className: "map-marker"
                            }
                        }}
                        icon={{
                            url: pin,
                            scaledSize: new window.google.maps.Size(35, 35)
                        }}
                    />)
                })
                LoadingOverlayManager.hide();
                setReportData(dados)
            }
        } catch (error) {
            LoadingOverlayManager.hide();
            console.error("Erro ao solicitar o relatório:", error);
        }
    };

    return (
        <div className="report-page">
            <div className="report-form">
                <h5 style={{ color: '#fff', marginTop: 15 }}>Percurso Por Periodo</h5>
                <label style={{ color: '#fff' }} htmlFor="startDate">Inicio:</label>
                <input
                    type="datetime-local"
                    id="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />

                <label style={{ color: '#fff' }} htmlFor="endDate">Final:</label>
                <input
                    type="datetime-local"
                    id="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />

                <label style={{ color: '#fff' }} htmlFor="vehicleId">Veículo:</label>
                <select
                    id="vehicleId"
                    value={vehicleId}
                    onChange={(e) => setVehicleId(e.target.value)}
                >
                    <option value="">Selecione um veículo</option>
                    {vehicles.map(vehicle => (
                        vehicle.type !== "NEW" && (
                            <option key={vehicle.id} value={vehicle.id}>
                                {vehicle.plate}
                            </option>
                        )
                    ))}
                </select>

                <button onClick={handleSubmit} className="submit-btn">Solicitar Relatório</button>
                {reportData && (<label style={{ color: '#fff' }}>Trip: {(trip / 1000).toFixed(2)}Km</label>)}
            </div>

            {isLoaded && (
                <div className="map-container">
                    <GoogleMap
                        mapContainerStyle={{ width: '100%', height: "100%" }}
                        center={{ lat: centerPositions.lat, lng: centerPositions.lng }}
                        zoom={centerPositions.zoom}
                    >
                        {reportData != null && reportData}

                        {/* Adiciona Polyline para o trajeto */}
                        <Polyline
                            path={reportData.map(marker => ({
                                lat: marker.props.position.lat,
                                lng: marker.props.position.lng
                            }))}
                            options={{
                                strokeColor: "#4c3971", // Cor da linha
                                strokeOpacity: 0.8,
                                strokeWeight: 2
                            }}
                        />

                        {selectedPosition && (
                            <InfoWindow
                                position={{
                                    lat: selectedPosition.latitude,
                                    lng: selectedPosition.longitude
                                }}
                                onCloseClick={() => {
                                    setCenterPositions({ lat: selectedPosition.latitude, lng: selectedPosition.longitude, zoom: 15 });
                                    setSelectedPosition(null);
                                }}
                            >
                                <div>
                                    <h3>{selectedPosition.plate}</h3>
                                    <h5 style={{ fontStyle: 'oblique' }}>{`${selectedPosition.nearDesc}`}</h5>
                                    <p>{`Velocidade: ${selectedPosition.speed.toFixed(2)}Km/h`}</p>
                                    <p>{`Ignição: ${selectedPosition.ignition === 0 ? 'Desligada' : 'Ligada'}`}</p>
                                    <p>{`Hodometro: ${(selectedPosition.odometerGps / 1000).toFixed(2)}Km`}</p>
                                    <p>{`Dia: ${moment(selectedPosition.dateTime).subtract(3, "hours").format("DD/MM/yyyy")} Hora: ${moment(selectedPosition.dateTime).subtract(3, "hours").format("HH:mm:ss")}`}</p>
                                </div>
                            </InfoWindow>
                        )}
                    </GoogleMap>
                </div>
            )}
        </div>
    );
};

export default ReportPagePerc;
